import { render } from "./transferSubject.vue?vue&type=template&id=a9dad6a8&scoped=true"
import script from "./transferSubject.js?vue&type=script&lang=js"
export * from "./transferSubject.js?vue&type=script&lang=js"

import "./transferSubject.vue?vue&type=style&index=0&id=a9dad6a8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9dad6a8"]])

export default __exports__